Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _makeIcon = require('../../private/makeIcon');

var _makeIcon2 = _interopRequireDefault(_makeIcon);

var _iconCategories = require('../../utils/iconCategories');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DrawerSettingsSvg = function () {
  function DrawerSettingsSvg(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'm23.34 14.27-.5-.28c-1.98-1.08-1.99-2.66-.02-3.76l.57-.32c.52-.29.74-.93.52-1.48l-.88-2.18a1.2 1.2 0 0 0 -1.4-.7l-.63.17c-2.17.58-3.27-.56-2.59-2.71l.17-.55a1.18 1.18 0 0 0 -.66-1.41l-2.17-.92a1.17 1.17 0 0 0 -1.48.51l-.27.5c-1.08 1.98-2.67 1.98-3.76.01l-.31-.56a1.19 1.19 0 0 0 -1.48-.52l-2.18.88c-.55.22-.85.83-.7 1.4l.17.63c.58 2.17-.56 3.27-2.72 2.59l-.55-.17a1.18 1.18 0 0 0 -1.41.64l-.96 2.2a1.16 1.16 0 0 0 .51 1.47l.54.3c1.98 1.07 1.98 2.64.01 3.74l-.56.31a1.19 1.19 0 0 0 -.52 1.48l.88 2.18c.22.55.83.85 1.4.7l.61-.16c2.19-.59 3.28.55 2.61 2.71l-.17.55c-.17.55.11 1.18.64 1.41l2.2.97a1.16 1.16 0 0 0 1.47-.51l.3-.54c1.07-1.98 2.65-1.98 3.74-.01l.31.56c.29.52.93.74 1.48.52l2.18-.88c.55-.22.85-.83.7-1.4l-.17-.61c-.59-2.18.55-3.27 2.71-2.61l.55.17a1.18 1.18 0 0 0 1.41-.66l.92-2.17c.23-.54.01-1.19-.51-1.48zm-.42 1.08-.92 2.17c-.03.07-.13.12-.2.1l-.55-.17c-2.91-.9-4.76.88-3.97 3.82l.17.61c.02.08-.03.18-.11.21l-2.18.88a.19.19 0 0 1 -.23-.08l-.31-.56c-1.48-2.66-4.04-2.65-5.49.02l-.3.54c-.03.06-.13.09-.19.07l-2.2-.97c-.06-.03-.11-.13-.09-.2l.17-.54c.91-2.91-.88-4.76-3.82-3.98l-.62.16a.2.2 0 0 1 -.21-.11l-.88-2.18a.19.19 0 0 1 .08-.23l.56-.31c2.66-1.48 2.65-4.04-.02-5.49l-.54-.3c-.06-.03-.09-.13-.07-.19l.96-2.2c.03-.06.13-.11.2-.09l.54.17c2.91.9 4.76-.87 3.98-3.81l-.17-.63c-.02-.08.03-.18.11-.21l2.18-.88a.19.19 0 0 1 .23.08l.31.56c1.48 2.66 4.05 2.66 5.51-.01l.27-.5c.03-.06.13-.1.21-.07l2.17.92c.07.03.12.13.1.19l-.17.55c-.9 2.91.87 4.76 3.81 3.98l.63-.17a.2.2 0 0 1 .22.11l.88 2.18a.19.19 0 0 1 -.08.23l-.57.32c-2.66 1.47-2.64 4.05.03 5.51l.5.27c.06.03.1.13.07.21zm-10.93-8.36a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z',
        fillRule: 'evenodd'
      })
    );
  }

  return DrawerSettingsSvg;
}();

DrawerSettingsSvg.componentCategory = 'Core';
DrawerSettingsSvg.displayName = 'DrawerSettingsSvg';
DrawerSettingsSvg.defaultProps = {
  viewBox: '0 0 24 24'
};


var IconDrawerSettings = (0, _makeIcon2['default'])(DrawerSettingsSvg, 'IconDrawerSettings');
exports['default'] = IconDrawerSettings;


if (process.env.NODE_ENV !== 'production') {
  IconDrawerSettings.categories = [_iconCategories.SIDE_DRAWER];
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/icons/IconDrawerSettings.js
// module id = 423
// module chunks = 19843951674672